<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        navigationTitle="活动详情"
        phoneBodyOverflowHidden
      >
        <div slot="headerSlot">
          <div class="bg"></div>
        </div>
        <div class="slot">
          <div
            class="header-img-wrapper redeem-upload "
            :class="{ 'prev-upload': type !== 'detail' }"
          >
            <el-upload
              class="upload flex flex-center"
              ref="upload"
              :disabled="type === 'detail'"
              :limit="1"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :on-remove="handleRemove"
              :onError="uploadError"
              :http-request="customUpload"
              :onProgress="uploading"
            >
              <div
                class="upload-img"
                v-if="ruleForm.drawImg && type !== 'detail'"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div
                class="empty"
                style="margin-top:60px; font-size: 12px"
                v-if="!ruleForm.drawImg"
              >
                还没有奖券图片立即
                <el-button type="primary" size="mini">添加</el-button>
              </div>
            </el-upload>
            <img
              class="header-img"
              v-if="ruleForm.drawImg"
              :src="ruleForm.drawImg"
              alt=""
            />
          </div>
          <div class="preview-container">
            <div class="act-info-wrapper">
              <div class="info flex flex-between">
                <div class="flex-1">
                  <div class="title">{{ ruleForm.drawName }}</div>
                  <div class="flex">
                    <div
                      class="time"
                      :class="{ 'prev-upload': type !== 'detail' }"
                    >
                      <div
                        class="upload-img"
                        @click="addTime"
                        v-if="type !== 'detail'"
                      >
                        <span
                          class="hmicon icon-shangchuantupian1 icon-hao pointer"
                        ></span>
                      </div>
                      抽奖时间：
                      <template
                        v-if="
                          ruleForm.activityDate && ruleForm.activityDate.length
                        "
                      >
                        <span
                          >{{
                            ruleForm.activityDate[0]
                              .split(" ")[0]
                              .replace(/\-/g, "/")
                              .substring(5, 10)
                          }}-</span
                        >
                        <span>{{
                          ruleForm.activityDate[1]
                            .split(" ")[0]
                            .replace(/\-/g, "/")
                            .substring(5, 10)
                        }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <span class="count-wrapper" v-if="ruleForm.remainExchangeNum">
                可用抽奖券{{ ruleForm.remainExchangeNum }}张
              </span>
              <div
                class="flex flex-between btn-wrapper"
                v-if="type !== 'history'"
              >
                <button class="flex-1 btn round exchange">
                  去兑换
                </button>
                <button
                  @click="lottery"
                  v-if="ruleForm.remainExchangeNum"
                  class="flex-1 btn round ing"
                >
                  去抽奖
                </button>
              </div>
            </div>
            <div class="tips-wrapper">
              当日订单只可兑换当日抽奖券，且抽券当日活动时间内有效，过期作废。且该活动单次只可兑换一张抽奖券。
            </div>
            <div class="main-wrapper">
              <div class="main">
                <div class="rule">
                  <div class="title">奖券使用规则</div>
                  <div class="content">
                    <div>
                      订单合计金额每满{{
                        ruleForm.prizeModelList.length
                          ? ruleForm.prizeModelList[0].limitAmount || 0
                          : 0
                      }}元可兑换一次抽奖
                    </div>
                    <div>
                      兑换的抽奖券只可用于该抽奖活动
                    </div>
                  </div>
                </div>
                <div
                  class="prize "
                  :class="{ 'prev-upload': type !== 'detail' }"
                >
                  <div class="prize-header">
                    抽奖奖品
                  </div>
                  <div class="prize-table">
                    <div class="table-header flex">
                      <span class="th td">奖项</span>
                      <span class="flex-1 td">奖品名</span>
                      <!-- <span class="th td">奖品总数</span> -->
                      <span class="th td">剩余</span>
                    </div>
                    <div class="table-body">
                      <div
                        class="prize-list"
                        v-for="(item, index) in ruleForm.prizeModelList"
                        :key="index"
                      >
                        <div
                          class="upload-img"
                          v-if="type !== 'detail'"
                          @click="addGoodChild(index, 0)"
                        >
                          <span
                            class="hmicon icon-shangchuantupian1 icon-hao pointer"
                          ></span>
                        </div>
                        <div
                          class="delete-item"
                          @click="deleteGoodChild(index, 0)"
                        >
                          <span
                            class="hmicon  hmicon icon-shanchu1 pointer"
                          ></span>
                        </div>
                        <div
                          class="prize-item flex"
                          v-for="(v, i) in item.drawPrizeModelList"
                          :key="i"
                        >
                          <span class="th td">{{ v.prizeLevel }}</span>
                          <span class="flex-1 td">{{ v.prizeName }}</span>
                          <!-- <span class="flex-1 td">{{v.prizeName}}x{{v.prizeNum}}</span> -->
                          <!-- <span class="th td">{{v.prizeLevelNum}}</span> -->
                          <span class="th td">0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="抽奖名称" prop="drawName">
            <el-input
              size="small"
              :disabled="type === 'detail'"
              clearable
              class="mr10 ipt"
              maxlength="18"
              v-model.trim="ruleForm.drawName"
              placeholder="请输入规则名称"
            ></el-input>
            <div class="form-item-tip">
              规则名称最多18个字
            </div>
          </el-form-item>
          <el-form-item label="背景音乐链接" prop="gameBgm">
            <div class="flex item-center">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.gameBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>

              <i
                v-if="ruleForm.gameBgm"
                @click="startPlay('audio')"
                style="font-size:25px"
                class="el-icon-video-play"
              ></i>

              <i
                v-if="ruleForm.gameBgm"
                @click="pausePlay('audio')"
                style="font-size:25px"
                class="el-icon-video-pause ml10"
              ></i>

              <audio
                v-if="ruleForm.gameBgm"
                id="audio"
                ref="audio"
                :src="ruleForm.gameBgm"
                preload
              >
                对不起，您的浏览器不支持HTML5音频播放。
              </audio>
            </div>
          </el-form-item>
          <el-form-item label="中奖音乐" prop="winningBgm">
            <div class="flex item-center">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.winningBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>
              <i
                v-if="ruleForm.winningBgm"
                @click="startPlay('audio1')"
                style="font-size:25px"
                class="el-icon-video-play"
              ></i>

              <i
                v-if="ruleForm.winningBgm"
                @click="pausePlay('audio1')"
                style="font-size:25px"
                class="el-icon-video-pause ml10"
              ></i>

              <audio
                v-if="ruleForm.winningBgm"
                id="audio1"
                ref="audio1"
                :src="ruleForm.winningBgm"
                preload
              >
                对不起，您的浏览器不支持HTML5音频播放。
              </audio>
            </div>
          </el-form-item>
          <el-form-item label="未中奖音乐" prop="notWinningBgm">
            <div class="flex item-center">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.notWinningBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>
              <i
                v-if="ruleForm.notWinningBgm"
                @click="startPlay('audio2')"
                style="font-size:25px"
                class="el-icon-video-play"
              ></i>
              <i
                v-if="ruleForm.notWinningBgm"
                @click="pausePlay('audio2')"
                style="font-size:25px"
                class="el-icon-video-pause ml10"
              ></i>

              <audio
                v-if="ruleForm.notWinningBgm"
                id="audio2"
                ref="audio2"
                :src="ruleForm.notWinningBgm"
                preload
              >
                对不起，您的浏览器不支持HTML5音频播放。
              </audio>
            </div>
          </el-form-item>
          <el-form-item label="抽奖时间" prop="activityDate">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.activityDate"
              type="datetimerange"
              align="right"
              ref="datePicker"
              :picker-options="pickerOptions"
              :disabled="type === 'detail'"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="匹配订单时间" prop="matchOrderMode">
            <el-radio-group
              v-model="ruleForm.matchOrderMode"
              size="small"
              :disabled="type === 'detail'"
            >
              <el-radio label="today">当天订单</el-radio>
              <el-radio label="range">时段订单</el-radio>
            </el-radio-group>
            <div class="form-item-tip">
              选择当日订单情况下，在抽奖活动开时候当日订单当日兑换抽奖券、并且当日抽奖，过期无效。
            </div>
            <div v-if="ruleForm.matchOrderMode === 'range'">
              <el-date-picker
                :disabled="type === 'detail'"
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.matchOrderDate"
                type="datetimerange"
                align="right"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item
            label="核销订单来源"
            prop="orderSource"
            v-if="queryConfigFlag"
          >
            <el-radio-group
              v-model="ruleForm.orderSource"
              size="small"
              :disabled="type === 'detail'"
              @change="shopIdsChange"
            >
              <el-radio label="online">线上</el-radio>
              <el-radio label="offline">线下</el-radio>
            </el-radio-group>
            <div v-if="ruleForm.orderSource === 'offline'">
              <span class="title">选择门店：</span>
              <span class="form-item-tip">
                (注：若不选择门店，则默认
                <strong>不限制</strong>)
              </span>
              <div class="tip">
                核销订单来源选择线下时，可选择门店，选择的对应门店的订单才可参与抽奖
              </div>
              <div>
                <el-select
                  size="small"
                  multiple
                  filterable
                  clearable
                  placeholder="选择门店"
                  :disabled="type === 'detail'"
                  v-model="ruleForm.shopIds"
                  class="width-auto mr10"
                  style="width:300px"
                >
                  <el-option
                    v-for="(item, i) in allShopList"
                    :key="i"
                    :label="item.shopName"
                    :value="item.shopId"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="订单商品限制" prop="goodsStatus">
            <el-radio-group v-model="ruleForm.goodsStatus" size="small">
              <el-radio label="no">全部商品</el-radio>
              <el-radio label="yes">部分商品</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="可选商品"
            prop=""
            v-if="ruleForm.goodsStatus === 'yes'"
          >
            <span class="form-item-tip">
              (注：若不设置商品规则，则默认
              <strong>购买任意商品的订单都参与活动抽奖</strong>)
            </span>

            <hm-sweep-transfer
              ref="goodsTransfer"
              showUseable
              showBarcode
              @checkGoods="checkGoods"
              :leftOption="leftGoodsRules"
            >
            </hm-sweep-transfer>
          </el-form-item>
          <el-form-item label="抽奖模式" prop="drawMode">
            <el-radio-group
              v-model="ruleForm.drawMode"
              size="small"
              :disabled="type === 'detail'"
            >
              <el-radio label="online">线上抽奖</el-radio>
              <el-radio label="offline">线下抽奖</el-radio>
              <el-radio label="mix">混合抽奖</el-radio>
            </el-radio-group>
            <!-- <div class="form-item-tip" style="color:red">
          只有使用线上抽奖才会触发自动发券！
        </div> -->
          </el-form-item>
          <el-form-item label="单次兑换券数" prop="singleExchangeUpperLimit">
            <el-input
              :disabled="type === 'detail'"
              size="small"
              clearable
              class="mr10 ml10 ipt"
              maxlength="18"
              style="width:300px"
              v-model.trim="ruleForm.singleExchangeUpperLimit"
              placeholder="请输入正整数，不填则表示不限制"
            ></el-input>
            <div class="form-item-tip">
              表示单次兑换抽奖券的数量限制，即一次兑换无论选择的订单总额达到多少都只能兑换上限数量的券。
            </div>
          </el-form-item>
          <el-form-item label="抽奖门槛" prop="prizeModelList">
            <div
              v-for="(v, index) in ruleForm.prizeModelList"
              :key="index"
              class="mb20"
            >
              <div class="flex flex-wrap item-center">
                订单合计金额满
                <el-input
                  size="small"
                  clearable
                  class="mr10 ml10 ipt"
                  maxlength="60"
                  style="width:100px"
                  v-model.trim="v.limitAmount"
                  @input="filterGt0OrFixed2(index, 'limitAmount')"
                  :disabled="type === 'detail'"
                  placeholder=""
                ></el-input
                >元，参与抽奖。
                <!-- <div v-if="type !== 'detail'">
              <div class="add-wrapper flex flex-center" v-if="index === 0">
                <span
                  class="hmicon icon-hao pointer"
                  @click="addChild(index)"
                ></span>
              </div>
              <div class="minus-wrapper flex flex-center" v-else>
                <span
                  class="hmicon icon-jianhao pointer"
                  @click="deleteChild(index)"
                ></span>
              </div>
            </div> -->
              </div>
              <div class="table-goods">
                <el-table
                  :data="v.drawPrizeModelList"
                  style="width: 100%"
                  ref="table"
                  stripe
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="奖项"
                    prop="prizeLevel"
                  >
                    <template slot-scope="scope">
                      <el-input
                        :disabled="type === 'detail'"
                        size="small"
                        clearable
                        class="mr10 ml10 ipt"
                        maxlength="60"
                        style="width:200px"
                        v-model.trim="scope.row.prizeLevel"
                        placeholder="请输入奖项"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="奖品类型"
                    prop="prizeType"
                  >
                    <template slot-scope="scope">
                      <el-select
                        :disabled="type === 'detail'"
                        v-model="scope.row.prizeType"
                        placeholder="请选择奖品类型"
                        size="small"
                        class="mr10"
                        @change="prizeTypeChange(scope.$index)"
                        filterable
                      >
                        <el-option label="实物商品" value="gift"></el-option>
                        <!-- <el-option label="兑换券" value="voucher"></el-option> -->
                        <el-option label="优惠劵" value="coupon"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="奖品名称"
                    prop="prizeName"
                  >
                    <template slot-scope="scope">
                      <el-input
                        :disabled="type === 'detail'"
                        v-if="scope.row.prizeType === 'gift'"
                        size="small"
                        clearable
                        class="mr10 ml10 ipt"
                        maxlength="18"
                        style="width:200px"
                        v-model.trim="scope.row.prizeName"
                        placeholder="请输入实物名称"
                      ></el-input>
                      <el-input
                        v-if="scope.row.prizeType === 'coupon'"
                        :disabled="type === 'detail'"
                        size="small"
                        clearable
                        @click.native="
                          selectGoods(scope.row.prizeType, scope.$index)
                        "
                        class="mr10 ml10 ipt"
                        maxlength="18"
                        style="width:200px"
                        v-model.trim="scope.row.prizeName"
                        placeholder="奖品名称"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="奖品图片"
                    prop="prizeImg"
                  >
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <div
                          class="flex goods-upload-btn"
                          @click="
                            addGoodsImg(
                              scope.row,
                              index,
                              scope.$index,
                              'prizeImg'
                            )
                          "
                          v-if="!scope.row.prizeImg"
                        >
                          <div
                            style="margin-left:0px"
                            class="btn flex flex-column flex-center open-file item-center"
                          >
                            <div class="add-prize-img-wrapper">
                              <span class="hmicon icon-hao pointer"></span>
                            </div>
                            <span>添加图片</span>
                          </div>
                        </div>
                        <div v-else class="mr10 flex item-end priviews">
                          <!-- <img class="logo" :src="scope.row.prizeImg" alt="logo" /> -->
                          <el-image
                            class="img"
                            :src="scope.row.prizeImg"
                            alt="logo"
                            :preview-src-list="[scope.row.prizeImg]"
                          />
                          <div
                            class="opreat-wrapper flex item-center flex-center"
                          >
                            <el-button
                              type="text"
                              @click="handleRemovelist(index, scope.$index)"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="奖品总数"
                    prop="prizeLevelNum"
                  >
                    <template slot-scope="scope">
                      <el-input
                        :disabled="type === 'detail'"
                        size="small"
                        clearable
                        class="mr10 ml10 ipt"
                        maxlength="18"
                        style="width:200px"
                        @input="
                          filterGt0OrFixed0(
                            index,
                            scope.$index,
                            'prizeLevelNum'
                          )
                        "
                        v-model.trim="scope.row.prizeLevelNum"
                        placeholder="请输入奖品数量"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="winningRate"
                  >
                    <template slot="header">
                      <span class="mr10">中奖率</span>
                      <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                      >
                        <div>
                          中奖率合计不能超过100%
                        </div>
                        <span slot="reference">
                          <i class="el-icon-question" style="fontSize:20px"></i>
                        </span>
                      </el-popover>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex item-center">
                        <el-input
                          :disabled="type === 'detail'"
                          size="small"
                          clearable
                          class="mr10 ml10 ipt"
                          maxlength="18"
                          style="width:80px"
                          @input="
                            filterGt0OrFixed22(
                              index,
                              scope.$index,
                              'winningRate'
                            )
                          "
                          v-model.trim="scope.row.winningRate"
                          placeholder="中奖率"
                        ></el-input
                        >%
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="出奖门槛（总抽奖数到达多少次）"
                    prop="awardThreshold"
                  >
                    <template slot-scope="scope">
                      <div class="flex item-center">
                        <el-input
                          :disabled="type === 'detail'"
                          size="small"
                          clearable
                          class="mr10 ml10 ipt"
                          maxlength="18"
                          style="width:100px"
                          @input="
                            filterGt0OrFixed0(
                              index,
                              scope.$index,
                              'awardThreshold'
                            )
                          "
                          v-model.trim="scope.row.awardThreshold"
                          placeholder="请输入数字"
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="orderSn"
                    label="操作"
                    v-if="type !== 'detail'"
                  >
                    <template
                      slot-scope="scope"
                      class="flex flex-center"
                      v-if="type !== 'detail'"
                    >
                      <div
                        class="add-wrapper flex flex-center"
                        v-if="scope.$index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addGoodChild(index, scope.$index)"
                        ></span>
                      </div>
                      <div class="minus-wrapper flex flex-center" v-else>
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteGoodChild(index, scope.$index)"
                        ></span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-form-item>
          <div v-if="ruleForm.drawMode !== 'offline'">
            <el-form-item label="线上抽奖页面">
              <el-radio-group
                size="small"
                v-model="ruleForm.uiType"
                @change="handleClickTurnTable"
              >
                <el-radio-button
                  :label="v.value"
                  v-for="(v, i) in wheelTypeList"
                  :key="i"
                >
                  {{ v.name }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="上传背景图" prop="mainImgUrl">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess1"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                v-if="show"
                noCircle
                noSquare
                :width="750"
                :height="1334"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <!-- <el-button
                  type="primary"
                  size="small"
                  v-show="!gameBgp"
                  @click="toggleShow"
                  >上传</el-button
                >-->
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow1"
                  v-if="!ruleForm.gameBgp"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传活动背景图</span>
                </div>
                <div
                  v-if="ruleForm.gameBgp"
                  class="priview-imgurl mr10 flex item-end"
                >
                  <img :src="ruleForm.gameBgp" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow1">更换</el-button>
                  </div>
                </div>
              </div>
              <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
            </el-form-item>

            <el-form-item label="上传转盘图" prop="gameBgp2">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccessBgp2"
                @crop-upload-fail="cropUploadFail"
                v-model="showgameBgp2"
                v-if="showgameBgp2"
                noCircle
                noSquare
                :width="642"
                :height="642"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>

              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShowgameBgp2"
                  v-if="!ruleForm.gameBgp2"
                >
                  <div class="add-wrapper flex flex-center">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传转盘图</span>
                </div>
                <div
                  v-if="ruleForm.gameBgp2"
                  class="priviewbgp2 mr10 flex item-end"
                >
                  <img :src="ruleForm.gameBgp2" alt="转盘图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShowgameBgp2"
                      >更换</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="上传转盘指针图" prop="gameBgp3">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccessBgp3"
                @crop-upload-fail="cropUploadFail"
                v-model="showgameBgp3"
                noCircle
                noSquare
                :width="150"
                :height="160"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShowgameBgp3"
                  v-if="!ruleForm.gameBgp3"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传转盘指针图</span>
                </div>
                <div
                  v-if="ruleForm.gameBgp3"
                  class="priviewbgp3 mr10 flex item-end"
                >
                  <img :src="ruleForm.gameBgp3" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShowgameBgp3"
                      >更换</el-button
                    >
                  </div>
                </div>
              </div>
              <!-- <span class="form-tip"
                  >图片尺寸建议750x1334（最多上传一张）</span
                >-->
            </el-form-item>
          </div>

          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model="ruleForm.remark"
              :disabled="type === 'detail'"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="奖券图片" prop="drawImg">
            <el-upload
              class="upload flex"
              ref="upload"
              :disabled="type === 'detail'"
              :limit="1"
              drag
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :on-remove="handleRemove"
              :onError="uploadError"
              :http-request="customUpload"
              :onProgress="uploading"
            >
              <div v-if="ruleForm.drawImg" class=" flex item-end priview">
                <img
                  :src="ruleForm.drawImg"
                  style="width:360px;height:180px"
                  alt="logo"
                />
                <div
                  v-if="type !== 'detail'"
                  class="opreat-wrapper flex item-center flex-center"
                >
                  <el-button type="text">更换</el-button>
                </div>
              </div>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸为690x260像素的png图
                  <br />2.图片格式：只能上传jpg/png文件
                </span>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="flex flex-center mt20">
          <el-button
            type="primary"
            v-if="type !== 'detail'"
            size="small"
            @click="submitForm('ruleForm')"
            >发布</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
      </div>
    </div>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-coupons-or-vouchers
      type="microShop"
      :visible="dialogVisibleCoupons"
      :radio="isRadio"
      :filterType="filterType"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisibleCoupons = false"
    ></hm-filter-coupons-or-vouchers>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess1"
      @crop-upload-fail="cropUploadFail"
      v-model="showPrizeImg"
      noCircle
      noSquare
      :width="100"
      :height="100"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
  </div>
</template>

<script>
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterCouponsOrVouchers from "@/components/HmFilterCouponsOrVouchers";
import HmSweepTransfer from "@/components/HmSweepTransfer";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import { customImageUpload } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
export default {
  components: {
    HmFilterMicroShopGoods,
    HmFilterCouponsOrVouchers,
    actPreview,
    HmSweepTransfer,
    myUpload
  },
  data() {
    const profitGoodsLimit = (rule, val, callback) => {
      if (this.ruleForm.goodsStatus === "yes") {
        if (!this.$refs.goodsTransfer.rightData.length) {
          return callback(new Error("请选择商品！"));
        }
      }
      callback();
    };
    const profitDrawNameValue = (rule, val, callback) => {
      // if (this.checkDrawName()) {
      //   return callback(new Error("活动名称不能重复"));
      // }
      callback();
    };
    const profitmatchOrderMode = (rule, val, callback) => {
      if (val === "range") {
        if (this.ruleForm.matchOrderDate.length === 0) {
          return callback(new Error("请选择匹配订单时间段"));
        }
      }
      callback();
    };
    const profitprizeModelList = (rule, val, callback) => {
      let flag = false;
      val.forEach(v => {
        if (v.limitAmount === "") {
          flag = true;
        } else {
          v.drawPrizeModelList.forEach(v => {
            if (v.prizeType === "coupon") {
              for (let key in v) {
                if (v[key] === "" && key !== "awardThreshold") {
                  flag = true;
                }
              }
            } else if (v.prizeType === "gift") {
              for (let key in v) {
                if (
                  v[key] === "" &&
                  key !== "awardThreshold" &&
                  key !== "prizeContent"
                ) {
                  flag = true;
                }
              }
            }
          });
        }
      });
      if (flag) {
        return callback(new Error("请填写完整!"));
      } else {
        let total = 0;

        val[0].drawPrizeModelList.forEach(v => {
          total += v.winningRate * 1;
        });
        if (total > 100) {
          return callback(new Error("中奖率合计不能超过100%!"));
        }
      }
      // if (val[0].limitAmount === "") {
      //   return callback(new Error("请填写第一条抽奖门槛金额"));
      // } else {
      // }

      callback();
    };
    return {
      show: false,
      showgameBgp2: false,
      showgameBgp3: false,
      leftGoodsRules: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      filterType: 0,
      dialogVisibleCoupons: false,
      dialogVisible: false,
      isRadio: true,
      type: this.$route.query.type,
      id: this.$route.query.id,
      wheelType: "wheel",
      ruleForm: {
        drawName: "",
        goodsStatus: "no",
        drawMode: "online",
        gameBgm: "https://imgcdn.hemiao100.com/ThemePictures/gameBgm.mp3",
        winningBgm: "https://imgcdn.hemiao100.com/ThemePictures/winningBgm.mp3",
        notWinningBgm: "",
        uiType: "wheel",
        gameBgp2:
          "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%B5%84%E6%BA%90%201.png",
        gameBgp3:
          "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png",
        gameBgp:
          "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E6%9C%AA%E6%A0%87%E9%A2%98-1.png",
        singleExchangeUpperLimit: "",
        orderSource: "online",
        activityDate: [],
        shopIds: [],
        matchOrderMode: "today",
        matchOrderDate: [],
        prizeModelList: [
          {
            limitAmount: "",
            drawPrizeModelList: [
              {
                sort: 0,
                prizeLevel: "一等奖",
                prizeType: "coupon",
                prizeImg: "",
                // prizeContent: "",
                prizeName: "",
                prizeLevelNum: "1",
                winningRate: "",
                awardThreshold: 0
              }
            ]
          }
        ],
        remark: "",
        drawImg:
          "https://imgcdn.hemiao100.com/decoration/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20201020180702.png"
      },
      rules: {
        // goodsLimit: {
        //   required: true,
        //   validator: profitGoodsLimit
        // },
        drawName: [
          {
            required: true,
            message: "请输入抽奖名称",
            trigger: "change"
          },
          { required: true, validator: profitDrawNameValue, trigger: "blur" }
        ],
        goodsStatus: {
          required: true,
          message: "请选择订单商品限制",
          trigger: "change"
        },
        singleExchangeUpperLimit: [
          {
            required: false,
            pattern: /^[1-9][0-9]*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        drawMode: {
          required: true,
          message: "请选择抽奖模式",
          trigger: "change"
        },
        orderSource: {
          required: true,
          message: "请选择核销订单来源",
          trigger: "change"
        },
        activityDate: {
          required: true,
          message: "请选择抽奖时间",
          trigger: "change"
        },
        matchOrderMode: {
          required: true,
          validator: profitmatchOrderMode,
          trigger: "blur"
        },
        prizeModelList: {
          required: true,
          validator: profitprizeModelList
        }
      },
      wheelTypeList: [
        {
          name: "传统转盘",
          value: "wheel",
          bg:
            "https://imgcdn.hemiao100.com/decoration/ps5d47cd77f534d8d5-6e21-476f-98c5-61b4c05d3495.png",
          gameBgp2:
            "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%B5%84%E6%BA%90%201.png",
          gameBgp3:
            "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png",
          gameBgp:
            "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E6%9C%AA%E6%A0%87%E9%A2%98-1.png"
        },
        {
          name: "九宫格转盘",
          value: "grid",
          bg:
            "https://imgcdn.hemiao100.com/decoration/ps9efb3fea5df5690f-b9f1-4a34-ae47-8a53ab175d50.png",
          gameBgp2:
            "https://imgcdn.hemiao100.com/decoration/ps824f88d97cc48044-c012-4cbd-8742-560cd616749c.png",
          gameBgp3:
            "https://imgcdn.hemiao100.com/mall/ps903789aaa93f578f-28ce-47e7-bfbd-37af592f9be1.png",
          gameBgp:
            "https://imgcdn.hemiao100.com/hemiaoBase/hmService/wheelAct-gridBg.png"
        },
        {
          name: "滚动转盘",
          value: "roll",
          bg:
            "https://imgcdn.hemiao100.com/decoration/ps8160345d748ad294-5717-4412-8f3d-dd2ac6f2b9d5.png",
          gameBgp2:
            "https://imgcdn.hemiao100.com/decoration/ps89dbc6bf3a87a4d5-e0ea-46f0-bd1b-67be1c617d2c.png",
          gameBgp3:
            "https://imgcdn.hemiao100.com/decoration/ps880204674c532487-4cd4-4d19-a6ab-6b006768935e.png",
          gameBgp:
            "https://imgcdn.hemiao100.com/decoration/ps8cebd012a8481faf-8ef1-4501-9294-4b963ab597f7.png"
        }
      ],
      queryConfigFlag: false,
      index: 0,
      allShopList: [],
      parentIndex: 0,
      showPrizeImg: false
    };
  },
  computed: mapGetters(["storeStyle"]),
  watch: {},
  created() {},
  mounted() {
    this.queryConfig();
    if (this.type !== "add") {
      this.queryDetails();
    }
    this.$store.dispatch("queryStoreStyle");
    this.queryAllShopList();
  },
  methods: {
    shopIdsChange() {
      this.ruleForm.shopIds = [];
    },
    // 当音频开始播放
    onPlay(res) {
      console.log("res: ", res);
    },
    // 开始播放
    startPlay(ref) {
      this.$refs[ref].play();
    },
    // 暂停
    pausePlay(ref) {
      this.$refs[ref].pause();
    },
    addGoodsImg(v, index, i, type) {
      this.uploadType = type;
      this.showPrizeImg = true;
      this.parentIndex = index;
      this.i = i;
    },
    // addChild() {
    //   if (
    //     this.wheelType === "grid" &&
    //     this.rule.turntablePrizeRuleList.length >= 7
    //   ) {
    //     this.$message({
    //       message: "九宫格转盘只能添加7个商品",
    //       type: "warning"
    //     });
    //     return;
    //   }
    //   this.rule.turntablePrizeRuleList.push({
    //     rankingSeqNum: "",
    //     prizeType: "1",
    //     typeValue: "",
    //     prizeName: "",
    //     prizeNum: "",
    //     prizePriority: ""
    //   });
    // },
    // deleteChild(index) {
    //   this.rule.turntablePrizeRuleList.splice(index, 1);
    // },
    toggleShow1() {
      this.show = !this.show;
      this.uploadType = "";
    },
    toggleShowgameBgp2() {
      this.showgameBgp2 = !this.showgameBgp2;
    },
    toggleShowgameBgp3() {
      this.showgameBgp3 = !this.showgameBgp3;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess1(jsonData) {
      if (this.uploadType === "prizeImg") {
        this.$set(
          this.ruleForm.prizeModelList[this.parentIndex].drawPrizeModelList[
            this.i
          ],
          "prizeImg",
          jsonData.result
        );
        this.$forceUpdate();

        return;
      }
      if (this.show) {
        this.ruleForm.gameBgp = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadSuccessBgp2(jsonData) {
      if (this.showgameBgp2) {
        this.ruleForm.gameBgp2 = jsonData.result;
      }
    },
    cropUploadSuccessBgp3(jsonData) {
      this.ruleForm.gameBgp3 = jsonData.result;
    },
    handleClickTurnTable(val) {
      this.wheelType = val;
      let row = this.wheelTypeList.filter(v => v.value === val);
      this.ruleForm.gameBgp = row[0].gameBgp;
      this.ruleForm.gameBgp2 = row[0].gameBgp2;
      this.ruleForm.gameBgp3 = row[0].gameBgp3;
    },
    checkGoods(val) {
      console.log("val: ", val);
      this.isCheckGoods = val;
    },
    async queryAllShopList() {
      const { result } = await this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
      this.allShopList = result.records;
    },
    toggleShow() {
      this.$refs.upload.submit();
    },
    selectGoods(val, i) {
      if (this.type !== "detail") {
        this.index = i;
        if (val === "gift") {
          this.dialogVisible = true;
        } else if (val === "voucher") {
          this.filterType = 1;
          this.dialogVisibleCoupons = true;
        } else if (val === "coupon") {
          this.filterType = 0;
          this.dialogVisibleCoupons = true;
        }
      }
    },
    saveGoods() {
      // if (data.length > 0) {
      //   this.dialogVisible = false;
      //   if (this.rule.length === 1) {
      //     this.rule = [];
      //   }
      //   if (this.sole) {
      //     this.rule.splice(this.rule.length - 1, 1);
      //   }
      //   this.rule.push(...data);
      // } else {
      //   this.$message({
      //     message: "请选择商品",
      //     type: "warning"
      //   });
      // }
    },
    prizeTypeChange(i) {
      this.ruleForm.prizeModelList[0].drawPrizeModelList[i].prizeName = "";
      this.ruleForm.prizeModelList[0].drawPrizeModelList[i].prizeContent = "";
    },
    setLink(data) {
      this.ruleForm.prizeModelList[0].drawPrizeModelList[this.index].prizeName =
        data.name;
      this.ruleForm.prizeModelList[0].drawPrizeModelList[
        this.index
      ].prizeContent = data.couponSendId;
      this.dialogVisibleCoupons = false;
      this.dialogVisible = false;
      this.isRadio = true;
    },
    async checkDrawName() {
      this.$store.dispatch("checkDrawName", {
        drawName: this.ruleForm.drawName
      });
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("detailsStoreOfflineDraw", {
        id: this.id
      });
      result.activityDate = [result.drawStartTime, result.drawEndTime];

      result.matchOrderDate =
        result.matchOrderMode === "today"
          ? []
          : [result.matchOrderStartTime, result.matchOrderEndTime];

      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      result.goodsRelModelList = result.goodsRelModelList || [];
      result.goodsRelModelList.forEach(v => {
        if (v.attrType === "goods") {
          v.tip = "货号";
        } else if (v.attrType === "barcode") {
          v.tip = "条码";
        } else if (v.attrType === "category") {
          v.tip = "品类";
        } else if (v.attrType === "brand") {
          v.tip = "品牌";
        }
      });
      setTimeout(() => {
        if (result.goodsStatus === "yes") {
          this.$refs.goodsTransfer.rightData = result.goodsRelModelList;
        }
      }, 1000);
      this.ruleForm.prizeModelList = this.sortByKey(
        this.ruleForm.prizeModelList,
        "limitAmount"
      );
    },
    async queryConfig() {
      const { result } = await this.$store.dispatch("configQuery", {
        code: "offlineDrawOrderSource"
      });

      this.queryConfigFlag = result.value === "yes" ? true : false;
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.drawStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.drawEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          if (params.matchOrderMode === "range") {
            params.matchOrderStartTime =
              this.ruleForm.matchOrderDate &&
              this.ruleForm.matchOrderDate.length > 0
                ? this.ruleForm.matchOrderDate[0]
                : "";
            params.matchOrderEndTime =
              this.ruleForm.matchOrderDate &&
              this.ruleForm.matchOrderDate.length > 0
                ? this.ruleForm.matchOrderDate[1]
                : "";
          }
          let flag = true;
          params.prizeModelList.forEach(v => {
            if (v.limitAmount == "0") {
              flag = false;
            }
          });
          if (params.goodsStatus === "yes") {
            params.goodsRelModelList = this.$refs.goodsTransfer.rightData;
          }
          if (flag) {
            if (this.type === "edit") {
              params.operationType = "edit";
              params.id = this.id;
            }
            let name =
              this.type === "edit"
                ? "editStoreOfflineDrawRule"
                : "addStoreOfflineDrawRule";
            this.$store.dispatch(name, params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.push({
                  name: "SweepstakesList"
                });
                // this.$router.back(-1);
              }
            });
          } else {
            this.$message({
              message: "订单合计金额不能为0！",
              type: "warning"
            });
          }
        } else {
          return false;
        }
      });
    },
    handleRemovelist(index, i) {
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i].prizeImg = "";
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.drawImg = "";
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.drawImg = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      //   this.isSaving = false;
    },
    // 正在上传
    uploading() {
      //   this.isSaving = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    async customUpload(options) {
      return customImageUpload({
        ...options,
        fileDir: 'mall',
        token: this.$token,
        onSuccess: (result) => {
         this.cropUploadSuccess(result);
          options.onSuccess(result);
        },
        onError: (error) => {
          this.$message({
            message: "图片上传失败，请重新选择图片!",
            type: "warning"
          });
          options.onError(error);
        }
      });
  },
    filterGt0OrFixed2(index, prop) {
      // this.ruleForm.prizeModelList[index][prop] = this.ruleForm.prizeModelList[
      //   index
      // ][prop].replace(/^(0+)/, ""); //过滤0开头

      this.ruleForm.prizeModelList[index][prop] = this.ruleForm.prizeModelList[
        index
      ][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.prizeModelList[index][prop] = this.ruleForm.prizeModelList[
        index
      ][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.prizeModelList[index][prop] = this.ruleForm.prizeModelList[
        index
      ][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.prizeModelList[index][prop] = this.ruleForm.prizeModelList[
        index
      ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数

      if (
        this.ruleForm.prizeModelList[index][prop].indexOf(".") < 0 &&
        this.ruleForm.prizeModelList[index][prop] != ""
      ) {
        //首位是0的话去掉

        this.ruleForm.prizeModelList[index][prop] = parseFloat(
          this.ruleForm.prizeModelList[index][prop]
        );
      }
    },
    filterGt0OrFixed22(index, i, prop) {
      // this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop].replace(
      //   /^(0+)/,
      //   ""
      // ); //过滤0开头
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop].indexOf(
          "."
        ) < 0 &&
        this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
          prop
        ] = parseFloat(
          this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop]
        );
      }
    },
    filterGt0OrFixed0(index, i, prop) {
      // this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
      //   prop
      // ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
      //   prop
      // ].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ].replace(/[^\d]/g, "");
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
      this.ruleForm.prizeModelList[index].drawPrizeModelList[i][
        prop
      ] = new Number(
        this.ruleForm.prizeModelList[index].drawPrizeModelList[i][prop]
      );
    },
    deleteChild(index) {
      this.ruleForm.prizeModelList.splice(index, 1);
    },
    addChild() {
      this.ruleForm.prizeModelList.push({
        limitAmount: "",
        drawPrizeModelList: [
          {
            sort: 0,
            prizeLevel: "一等奖",
            prizeType: "coupon",
            prizeContent: "一等奖",
            prizeName: "一等奖",
            prizeLevelNum: "1",
            winningRate: "",
            awardThreshold: 0
          }
        ]
      });
    },
    deleteGoodChild(index, i) {
      this.ruleForm.prizeModelList[index].drawPrizeModelList.splice(i, 1);
    },
    addTime() {
      this.$refs.datePicker.focus();
    },
    addGoodChild(index, i) {
      this.ruleForm.prizeModelList[index].drawPrizeModelList.push({
        sort: i + 1,
        prizeLevel:
          this.SectionToChinese(
            this.ruleForm.prizeModelList[index].drawPrizeModelList.length + 1
          ) + "等奖",
        prizeType: "coupon",
        prizeContent:
          this.SectionToChinese(
            this.ruleForm.prizeModelList[index].drawPrizeModelList.length + 1
          ) + "等奖",
        prizeName:
          this.SectionToChinese(
            this.ruleForm.prizeModelList[index].drawPrizeModelList.length + 1
          ) + "等奖",
        prizeLevelNum: "",
        prizeImg: ""
      });
    },
    SectionToChinese(section) {
      let chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
      ];
      let chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      let strIns = "",
        chnStr = "";
      let unitPos = 0;
      let zero = true;
      while (section > 0) {
        let v = section % 10;

        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    }
  }
};
</script>
<style lang="scss">
.table-goods {
  .cell {
    display: flex !important;
    display: -webkit-flex !important;
    justify-content: center;
    -webkit-justify-content: center;
  }
}
</style>
<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.table-goods {
  border: 1px solid #ddd;
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    position: absolute;
    left: 0;
    right: 0;
    top: 70px;
    height: 549px;
    overflow-y: auto;

    .exchange {
      background: linear-gradient(0deg, #ff711c, #ff9e2d);
      border: none;
      color: #fff;
      margin: 0 15px;
      &:active,
      &:focus {
        border: none;
        outline: 0;
      }
    }
    .tips-wrapper {
      padding: 9px 15px;
      color: #ff7e10;
      background: #fff2e7;
    }
    .rule {
      .title {
        font-weight: bold;
      }
      .content {
        margin: 5px 0 20px;
        line-height: 30px;
      }
    }
    .header-img-wrapper {
      box-sizing: border-box;
      padding: 0 15px;
      .header-img {
        width: 345px;
        height: 130px;
        display: block;
        border-radius: 5px;
      }
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }

    .preview-container {
      font-size: 14px;
      background: #fff;
      .act-info-wrapper {
        margin-bottom: 10px;
        .info {
          background: #fff;
          padding: 15px;
          .title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .time {
            height: 25px;
            line-height: 25px;
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;
            background: linear-gradient(to right, #fff, #f8f8f8, #efefef);
            padding-right: 15px;
            color: #666;
          }
        }
        .ad {
          margin: 0 auto 16px;
          width: 343px;
          height: 130px;
          .image {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }
        }
      }

      .main-wrapper {
        background: #f5f5f5;
        padding-top: 10px;
        .main {
          padding: 15px;
          background: #fff;
        }

        .order-header {
          font-size: 15px;
          .title {
            font-weight: bold;
            margin-right: 15px;
          }
          .price-wrapper {
            .price {
              color: #f72b2b;
              font-weight: bold;
            }
          }
        }

        .prize {
          margin-bottom: 15px;
        }

        .order-list {
          background: #f5f5f5;
          padding: 0 15px;
          margin-top: 15px;
          border-radius: 6px;
          margin-bottom: 26px;
          .order-item {
            padding: 15px 0;
            border-bottom: 1px solid #ddd;
          }
          .order-item:last-child {
            border: none;
          }
          .order-sn {
            margin-bottom: 10px;
          }
          .order-time {
            color: #666;
            font-size: 12px;
          }
          .price {
            color: #f72b2b;
            font-weight: bold;
          }
        }

        .prize-header {
          font-weight: bold;
        }
        .prize-table {
          border: 1px solid #ddd;
          border-radius: 6px;
          margin-top: 15px;
          .table-header {
            text-align: center;
            background: #f5f5f5;
            font-weight: bold;
          }
          .prize-item {
            text-align: center;
            border-bottom: 1px solid #ddd;
          }
          .prize-item:last-child {
            border-bottom: none;
          }
          .th {
            width: 75px;
          }
          .td {
            padding: 15px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
.priview-imgurl {
  position: relative;
  width: 400px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp2 {
  position: relative;
  width: 400px;
  height: 400px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp3 {
  position: relative;
  width: 150px;
  height: 161px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.priview {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.tip {
  color: red;
  font-size: 12px;
  line-height: 18px;
}

.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}

.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}

.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
